import React, { useState, useRef } from "react";
import { Modal, Button, Input } from "antd";
import {
  setCloseDashboardFlag,
  setDuplicateDashboardFlag,
  setEditTemplate,
  setFetchTemplateData,
  setOpenNewDashboardFlag,
  setSaveDashboardModalFlag,
  setSaveEditedDashboardModalFlag,
  updateDashboardGlobleFilters,
} from "../../../redux/actions/ApiCall/apiCall";
import { useDispatch, useSelector } from "react-redux";
import {
  deepCopy,
  getGlobalFilterAndFilterCountObject,
  getPaneIndex,
  getTemplateListBasicObject,
  removeHiddenFromSaved,
  removePrivateConversationFilters,
} from "../../../redux/constants";
import { memo } from "react";
import {
  onEdit,
  setDashboardFilters,
  setSelectedPillInPane,
} from "../../../redux/actions/dashboard/Tab1";
import { updateAuthParamsTemplateId } from "../../../redux/actions/AuthParams";

const { TextArea } = Input;

const SaveEditedDashboardModal = ({ isModalShow }) => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const All_Share_attributes = useSelector(
    (state) => state.WidgetMaker.All_Share_attributes
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  let index = getPaneIndex(panes, activeKey);

  const globalFinalFilter = getGlobalFilterAndFilterCountObject(
    "view_dashboard",
    deepCopy(panes[index]),
    graphConditionConfig
  );

  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const duplicateDashboardLoader = useSelector(
    (state) => state?.ApiCall?.duplicateDashboardLoader
  );
  const closeDashboardFlag = useSelector(
    (state) => state?.ApiCall?.closeDashboardFlag
  );
  const openNewDashboardFlag = useSelector(
    (state) => state?.ApiCall?.openNewDashboardFlag
  );
  const Allbrands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const sectionDetails = useSelector((state) => state.Section.sectionDetails);
  const isEditTemplate = useSelector((state) => state.Section.isEditTemplate);

  const [templateType, setTemplateType] = useState("custom");
  const [aggrigation, setAggrigation] = useState("avg");
  const [dashboardType, setDashboardType] = useState("custom");
  const [quickFilter, setQuickFilter] = useState("");
  const [channelList, setChannelList] = useState("");
  const [socialChannel, setSocialChannel] = useState(false);
  const [lock, setLock] = useState({
    is_brand_locked: false,
    is_date_locked: false,
  });

  const [isModalSaveAs, setIsModalSaveAs] = useState(false);
  const [dashboardName, setDashboardName] = useState(
    panes?.[index]?.template_name + " - " + "Version"
  );
  const [dashboardDescription, setDashboardDescription] = useState(
    panes?.[index]?.template_description
  );
  const [flag, setflag] = useState(false);

  const getWindowSize = () => {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  };

  const getPageSize = (windowSize) => {
    let currentWindowSize = windowSize?.innerWidth;

    if (currentWindowSize >= 2261) {
      return 21;
    } else if (currentWindowSize < 2261 && currentWindowSize >= 1905) {
      return 18;
    } else if (currentWindowSize < 1905 && currentWindowSize >= 1590) {
      return 15;
    } else if (currentWindowSize < 1590 && currentWindowSize >= 1278) {
      return 12;
    } else if (currentWindowSize < 1278 && currentWindowSize >= 966) {
      return 12;
    } else if (currentWindowSize < 966) {
      return 10;
    }
    return 12;
  };

  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [pageSize, setPageSize] = useState(getPageSize(windowSize));
  const [selectQuickFilter, setSelectQuickFilter] = useState(false);

  const handleCancel = () => {
    dispatch(setSaveEditedDashboardModalFlag(false));
    dispatch(setCloseDashboardFlag(false));
    dispatch(setOpenNewDashboardFlag(false));
  };

  const handleDontSave = () => {
    if (openNewDashboardFlag) {
      setIsModalSaveAs(false);
      // dispatch(setSaveDashboardModalFlag(false));
      dispatch(setSaveEditedDashboardModalFlag(false));

      let paneObj = {
        index: index,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        panes: panes,
        activeKey: activeKey,
        firstSection: true,
        templateDetails: templateDetails,
        global_dashboard_duration: global_dashboard_duration,
        global_dashboard_brands: global_dashboard_brands,
        global_dashboard_single_brands: global_dashboard_single_brands,
        competitorBrands: competitorBrands,
        type: window.location.pathname === "/schedule" ? "report" : "dashboard",
        graphConditionConfig: graphConditionConfig,
        temporary_words: temporary_words,
        is_modified_date:
          panes?.[index]?.template_id === "000-000-002" ||
          panes?.[index]?.template_id === "000-000-004"
            ? panes?.[index]?.is_modified_date
              ? panes?.[index]?.is_modified_date
              : false
            : null,
      };
      dispatch(
        onEdit(
          panes?.[index]?.key,
          "add",
          panes,
          activeKey,
          authParams,
          paneObj
        )
      );

      if (authParams?.template_id && authParams?.redirectToDIY) {
        dispatch(
          updateAuthParamsTemplateId(authParams, {
            template_id: null,
            // redirectToDIY: null,
          })
        );
      }
    } else if (closeDashboardFlag) {
      setIsModalSaveAs(false);
      // dispatch(setSaveDashboardModalFlag(false));
      dispatch(setSaveEditedDashboardModalFlag(false));

      let paneObj = {
        index: index,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        panes: panes,
        activeKey: activeKey,
        firstSection: true,
        templateDetails: templateDetails,
        global_dashboard_duration: global_dashboard_duration,
        global_dashboard_brands: global_dashboard_brands,
        global_dashboard_single_brands: global_dashboard_single_brands,
        competitorBrands: competitorBrands,
        type: window.location.pathname === "/schedule" ? "report" : "dashboard",
        graphConditionConfig: graphConditionConfig,
        temporary_words: temporary_words,
        is_modified_date:
          panes?.[index]?.template_id === "000-000-002" ||
          panes?.[index]?.template_id === "000-000-004"
            ? panes?.[index]?.is_modified_date
              ? panes?.[index]?.is_modified_date
              : false
            : null,
      };
      // console.log("Inside close panes", panes?.[index]);
      dispatch(
        onEdit(
          panes?.[index]?.key,
          "remove",
          panes,
          activeKey,
          authParams,
          paneObj
        )
      );

      if (authParams?.template_id && authParams?.redirectToDIY) {
        dispatch(
          updateAuthParamsTemplateId(authParams, {
            template_id: null,
            // redirectToDIY: null,
          })
        );
      }
    } else {
      // dispatch(setSaveDashboardModalFlag(false));
      dispatch(setSaveEditedDashboardModalFlag(false));
    }
  };

  const handleDontSave1 = () => {
    let index = getPaneIndex(panes, activeKey);
    let id = panes?.[index]?.template_id;

    panes[index].isDashboard = false;
    let paneObject = {
      index: window?.location?.pathname === "/schedule" ? 0 : index,
      //brands: panes[index]?.brands,
      brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : Allbrands,
      duration: panes[index]?.duration,
      panes: panes,
      activeKey: activeKey,
      firstSection: true,
      singleBrands: Allbrands,
      // global_dashboard_duration: global_dashboard_duration,
      // global_dashboard_brands: global_dashboard_brands,
      competitorBrands: competitorBrands,
      schedule: true,
      // isScheduleReportOpen: isScheduleReportOpen,
      graphConditionConfig: graphConditionConfig,
      // scheduleObj: scheduleObj,
      // already_opened_dashboard:
      //   isDashboardScheduleTemplate?.already_opened_dashboard,
    };
    authParams && dispatch(setFetchTemplateData(authParams, id, paneObject));
  };
  // const handleSaveAsDashboard = (e) => {
  //   let notMatchedFilters = removePrivateConversationFilters(
  //     panes?.[index]?.comp_hidden_filter,
  //     panes?.[index]?.filters,
  //     panes?.[index]?.saved_filters
  //   );

  //   const selectedPill = panes[index]?.selected_pills
  //     ? panes[index]?.selected_pills
  //     : [];
  //   if (selectedPill?.[0]?.saved_filters?.length) {
  //     notMatchedFilters = removeHiddenFromSaved(
  //       deepCopy(notMatchedFilters),
  //       deepCopy(selectedPill?.[0]?.saved_filters)
  //     );
  //     panes[index].filters = removeHiddenFromSaved(
  //       deepCopy(panes[index].filters),
  //       deepCopy(selectedPill?.[0]?.saved_filters)
  //     );
  //   }

  //   let obj = {
  //     template_id: panes?.[index]?.template_id,
  //     filters:
  //       panes?.[index]?.template_type === "competition"
  //         ? notMatchedFilters?.length
  //           ? notMatchedFilters
  //           : []
  //         : panes?.[index]?.filters?.length
  //         ? panes?.[index]?.filters
  //         : [],
  //     saveAsFlag: true,
  //     authParams: authParams,
  //     index: index,
  //     panes: panes,
  //   };

  //   // console.log("Call New API", obj);
  //   dispatch(updateDashboardGlobleFilters(obj));
  //   if (selectedPill?.[0]?.saved_filters?.length) {
  //     dispatch(setSelectedPillInPane(selectedPill?.[0], index, panes));
  //   }
  // };

  // Save changes in the Existing Dashboard
  const handleSaveAsDashboard = (e) => {
    saveEditedDashboard();
    dispatch(setSaveEditedDashboardModalFlag(false));
  };

  // const handleCreateNewDashboard = () => {
  //   setIsModalSaveAs(true);
  //   dispatch(setDuplicateDashboardFlag(true));
  //   dispatch(setSaveDashboardModalFlag(false));
  // };

  // Duplicate the Existing Dashboard
  const handleCreateNewDashboard = () => {
    saveEditedDashboard();
    dispatch(setSaveEditedDashboardModalFlag(false));
  };

  // Call update-template API
  const saveEditedDashboard = () => {
    // console.log("Inside saveEditedDashboard");
    let index = getPaneIndex(panes, activeKey);
    let filtersData = panes?.[index]?.filters ? panes?.[index]?.filters : [];

    if (panes?.[index]?.quick_filter || panes?.[index]?.hidden_filter) {
      if (
        panes?.[index]?.template_type === "competition" ||
        (panes?.[index]?.template_type === "competition" &&
          ["custom", "benchmarking"]?.includes(panes?.[index]?.template_type))
      ) {
        filtersData = removePrivateConversationFilters(
          graphConditionConfig?.comp_hidden_filter,
          filtersData
        );
      }
      filtersData = filtersData ? filtersData : [];
      // panes[index].selected_pills = [];
      dispatch(setDashboardFilters(filtersData, index, panes));
    } else {
      if (
        panes?.[index]?.template_type === "competition" ||
        (panes?.[index]?.template_type === "competition" &&
          ["custom", "benchmarking"]?.includes(panes?.[index]?.template_type))
      ) {
        filtersData = removePrivateConversationFilters(
          graphConditionConfig?.comp_hidden_filter,
          filtersData
        );
      }
      filtersData = filtersData ? filtersData : [];
      dispatch(setDashboardFilters(filtersData, index, panes));
    }

    let panesSection = panes[index]?.sections
      ? panes[index]?.sections
      : panes[index]?.section;

    let sectionObject = panesSection?.map((el) => {
      if (el?.widgets) {
        let single_brands = [];
        let brandsGroupName = [];
        let brandFiltersColumns = el?.brandFilters?.[0]?.columns
          ? el?.brandFilters?.[0]?.columns
          : el?.brandFilters?.columns;
        if (el?.brands) {
          el?.brands?.length > 0 &&
            brandFiltersColumns?.map((el1) => {
              if (el1?.group) {
                brandsGroupName.push({
                  brand_group_name: el1?.brand_group_name,
                });
              }
            });
          el?.brands?.length > 0 &&
            brandFiltersColumns?.map((el1) => {
              if (!el1?.group) {
                single_brands.push({
                  brand_id: el1?.brand_id ? el1?.brand_id : el1?.name,
                  brand_name: el1?.brand_name
                    ? el?.brand_name
                    : el1?.brand_friendly_name,
                });
              }
            });
        } else if (el?.brand_groups?.length) {
          brandsGroupName = el?.brand_groups;
        } else if (el?.brand_ids?.length) {
          single_brands = el?.brand_ids;
        }
        // For Section case
        // console.log("brandsGroupName", brandsGroupName);
        // console.log("single_brands", single_brands);

        let sectionWidgetObject = [];
        el?.widgets &&
          el?.widgets?.map((e) => {
            if (!(e?.childId && e?.duplicate_for_brands)) {
              let single_brands1 = [];
              let brandsGroupName1 = [];
              let brandFiltersColumns = e?.brandFilters?.[0]?.columns
                ? e?.brandFilters?.[0]?.columns
                : e?.brandFilters?.columns;
              if (e?.brands) {
                e?.brands?.length > 0 &&
                  brandFiltersColumns?.map((el1) => {
                    if (el1?.group) {
                      brandsGroupName1.push({
                        brand_group_name: el1?.brand_group_name,
                      });
                    }
                  });
                e?.brands?.length > 0 &&
                  brandFiltersColumns?.map((el1) => {
                    if (!el1?.group) {
                      single_brands1.push({
                        brand_id: el1?.brand_id ? el1?.brand_id : el1?.name,
                        brand_name: el1?.brand_name
                          ? el1?.brand_name
                          : el1?.brand_friendly_name,
                      });
                    }
                  });
              } else if (e?.brand_groups?.length) {
                brandsGroupName1 = e?.brand_groups;
              } else if (e?.brand_ids?.length) {
                single_brands1 = e?.brand_ids;
              }
              // For Widget Level
              // console.log("brandsGroupName1", brandsGroupName1);
              // console.log("single_brands1", single_brands1);

              if (e?.x_axis || e?.y_series || e?.chart) {
                sectionWidgetObject.push({
                  filters: e?.filters
                    ? e?.filters?.filter(
                        (el) =>
                          el?.attribute?.toLowerCase() !== "brandid" &&
                          el?.attribute?.toLowerCase() !== "createddate"
                      )
                    : undefined,
                  id: e?.id ? e?.id : null,
                  type: e?.type ? e?.type : "widget-maker",
                  text:
                    e?.type === "rich-content" ||
                    e?.chart?.chart_type === "text"
                      ? e?.text
                      : undefined,
                  widget_name:
                    e?.duplicate_for_brands && e?.parentId
                      ? e?.originalWidgetName
                      : e?.widget_name
                      ? e?.widget_name
                      : null,
                  widget_description: e?.widget_description
                    ? e?.widget_description
                    : null,
                  x_axis: e?.x_axis,
                  y_axes: e?.y_axes?.length > 0 ? e?.y_axes : null,
                  y_series: e?.y_series,
                  filter_dropdown:
                    e?.filter_dropdown?.length > 0 ? e?.filter_dropdown : [],
                  brand_list: e?.brand_ids?.length
                    ? single_brands1?.length > 0
                      ? single_brands1
                      : []
                    : e?.brands
                    ? single_brands1?.length > 0
                      ? single_brands1
                      : []
                    : [],
                  brand_groups: e?.brand_groups?.length
                    ? brandsGroupName1?.length > 0
                      ? brandsGroupName1
                      : []
                    : e?.brands
                    ? brandsGroupName1?.length > 0
                      ? brandsGroupName1
                      : []
                    : [],
                  chart: e?.chart,
                  order_by: e?.order_by,
                  relative_duration: e?.relative_duration || null,
                  start_date: e?.duration?.from
                    ? e?.duration?.from
                    : e?.start_date,
                  end_date: e?.duration?.to ? e?.duration?.to : e?.end_date,
                  is_locked: e?.is_locked ? e?.is_locked : false,
                  span: e?.span ? e?.span : "full",
                  original_widget_id: isEditTemplate
                    ? e?.original_widget_id
                      ? e?.original_widget_id
                      : e?.widget_id
                    : e?.widget_id,
                  is_imported: true,
                  log: e?.log,
                  data_source: e?.data_source,
                  widget_id: e?.widget_id,
                  engine: e?.engine,
                  supported_filters: e?.supported_filters,
                  profile_filters: e?.profile_filters,
                  widget_uuid: e?.widget_uuid,
                  widget_description_on_icon: e?.widget_description_on_icon,
                  note: e?.note || null,
                  multilevel_breakdown: e?.multilevel_breakdown || null,
                });
              } else {
                sectionWidgetObject.push({
                  filters: e?.filters
                    ? e?.filters?.filter(
                        (el) =>
                          el?.attribute?.toLowerCase() !== "brandid" &&
                          el?.attribute?.toLowerCase() !== "createddate"
                      )
                    : undefined,
                  graph_type: e?.graph_type ? e?.graph_type : "",
                  id: e?.id ? e?.id : null,
                  is_custom: e?.is_custom ? e?.is_custom : false,
                  primary: e?.primary && e?.primary,
                  secondary: e?.secondary ? e?.secondary : null,
                  splits: e?.splits ? e?.splits : null,
                  widget_name:
                    e?.duplicate_for_brands && e?.parentId
                      ? e?.originalWidgetName
                      : e?.widget_name
                      ? e?.widget_name
                      : null,
                  base: e?.base ? e?.base : "mentions",
                  type: e?.type ? e?.type : "graph",
                  text:
                    e?.type === "rich-content" ||
                    e?.chart?.chart_type === "text"
                      ? e?.text
                      : undefined,
                  relative_duration: e?.relative_duration || null,
                  start_date: e?.duration?.from
                    ? e?.duration?.from
                    : e?.start_date,
                  end_date: e?.duration?.to ? e?.duration?.to : e?.end_date,
                  is_locked: e?.is_locked ? e?.is_locked : false,
                  span: e?.span ? e?.span : "full",
                  differential: e?.differential,
                  original_widget_id:
                    e?.type === "predefined" && isEditTemplate
                      ? e?.original_widget_id
                        ? e?.original_widget_id
                        : e?.widget_id
                      : e?.widget_id,
                  is_imported: e?.type === "predefined" ? true : false,
                  source_template: e?.source_template
                    ? e?.source_template
                    : e?.template_id,
                  stacked: e?.stacked,
                  percent: e?.percent,
                  brand_list: e?.brands
                    ? single_brands1?.length > 0
                      ? single_brands1
                      : []
                    : [],
                  brand_groups: e?.brands
                    ? brandsGroupName1?.length > 0
                      ? brandsGroupName1
                      : []
                    : [],
                  log: e?.log,
                  data_source: e?.data_source,
                  widget_id: e?.widget_id,
                  engine: e?.engine,
                  supported_filters: e?.supported_filters,
                  profile_filters: e?.profile_filters,
                  widget_uuid: e?.widget_uuid,
                  widget_description: e?.widget_description,
                  note: e?.note || null,
                });
              }
              if (e?.duplicate_for_brands && e?.parentId) {
                e["widget_name"] = e?.originalWidgetName;
                delete e?.duplicate_for_brands;
                delete e?.parentId;
                delete e?.childId;
                delete e?.span;
                delete e?.originalWidgetName;
                delete e?.com_brand_ids;
              }
            }
          });
        return {
          brand_list: el?.brand_ids?.length
            ? single_brands?.length > 0
              ? single_brands
              : []
            : el?.brands
            ? single_brands?.length > 0
              ? single_brands
              : []
            : [],
          brand_groups: el?.brand_groups?.length
            ? brandsGroupName?.length > 0
              ? brandsGroupName
              : []
            : el?.brands
            ? brandsGroupName?.length > 0
              ? brandsGroupName
              : []
            : [],
          section_name: el?.name
            ? el?.name
            : el?.section_name
            ? el?.section_name
            : "",
          section_description: el?.description
            ? el?.description
            : el?.section_description
            ? el?.section_description
            : "",
          relative_duration: el?.relative_duration || null,
          start_date: el?.duration?.from,
          end_date: el?.duration?.to,
          filters: el?.filters ? el?.filters : undefined,
          is_locked: el?.is_locked ? el?.is_locked : false,
          widgets: sectionWidgetObject,
          comp_brand_type:
            panes?.[index]?.template_type === "competition" &&
            (el?.comp_brand_type === false || el?.comp_brand_type === true)
              ? el?.comp_brand_type
              : undefined,
        };
      }
    });

    let widgetObject = [];

    panesSection?.map((el) => {
      return el?.widgets?.map((e) => {
        if (!(e?.childId && e?.duplicate_for_brands)) {
          let single_brands1 = [];
          let brandsGroupName1 = [];
          if (e?.brands) {
            e?.brands?.length > 0 &&
              e?.brandFilters?.columns?.map((el1) => {
                if (el1?.group) {
                  brandsGroupName1.push({
                    brand_group_name: el1?.brand_group_name,
                  });
                }
              });
            e?.brands?.length > 0 &&
              e?.brandFilters?.columns?.map((el1) => {
                if (!el1?.group) {
                  single_brands1.push({
                    brand_id: el1?.brand_id ? el1?.brand_id : el1?.name,
                    brand_name: el1?.brand_name
                      ? el1?.brand_name
                      : el1?.brand_friendly_name,
                  });
                }
              });
          }
          if (e?.x_axis || e?.y_series || e?.chart) {
            widgetObject.push({
              filters: e?.filters
                ? e?.filters?.filter(
                    (el) =>
                      el?.attribute?.toLowerCase() !== "brandid" &&
                      el?.attribute?.toLowerCase() !== "createddate"
                  )
                : undefined,
              id: e?.id ? e?.id : null,
              type: e?.type ? e?.type : "widget-maker",
              text:
                e?.type === "rich-content" || e?.chart?.chart_type === "text"
                  ? e?.text
                  : undefined,
              widget_name:
                e?.duplicate_for_brands && e?.parentId
                  ? e?.originalWidgetName
                  : e?.widget_name
                  ? e?.widget_name
                  : null,
              widget_description: e?.widget_description
                ? e?.widget_description
                : null,
              note: e?.note || null,
              x_axis: e?.x_axis,
              y_axes: e?.y_axes?.length > 0 ? e?.y_axes : null,
              y_series: e?.y_series,
              filter_dropdown:
                e?.filter_dropdown?.length > 0 ? e?.filter_dropdown : [],
              brand_list: e?.brand_ids?.length
                ? e?.brand_ids
                : e?.brands
                ? single_brands1?.length > 0
                  ? single_brands1
                  : []
                : [],
              brand_groups: e?.brand_groups?.length
                ? e?.brand_groups
                : e?.brands
                ? brandsGroupName1?.length > 0
                  ? brandsGroupName1
                  : []
                : [],
              chart: e?.chart,
              order_by: e?.order_by,
              relative_duration: e?.relative_duration || null,
              start_date: e?.duration?.from ? e?.duration?.from : e?.start_date,
              end_date: e?.duration?.to ? e?.duration?.to : e?.end_date,
              is_locked: e?.is_locked ? e?.is_locked : false,
              span: e?.span ? e?.span : "full",
              original_widget_id: isEditTemplate
                ? e?.original_widget_id
                  ? e?.original_widget_id
                  : e?.widget_id
                : e?.widget_id,
              is_imported: true,
              log: e?.log,
              data_source: e?.data_source,
              widget_id: e?.widget_id,
              engine: e?.engine,
              supported_filters: e?.supported_filters,
              profile_filters: e?.profile_filters,
              widget_uuid: e?.widget_uuid,
              widget_description_on_icon: e?.widget_description_on_icon,
              multilevel_breakdown: e?.multilevel_breakdown || null,
            });
          } else {
            widgetObject.push({
              filters: e?.filters
                ? e?.filters?.filter(
                    (el) =>
                      el?.attribute?.toLowerCase() !== "brandid" &&
                      el?.attribute?.toLowerCase() !== "createddate"
                  )
                : undefined,
              graph_type: e?.graph_type ? e?.graph_type : "",
              id: e?.id ? e?.id : null,
              is_custom: e?.is_custom ? e?.is_custom : false,
              primary: e?.primary && e?.primary,
              secondary: e?.secondary ? e?.secondary : null,
              splits: e?.splits ? e?.splits : null,
              widget_name:
                e?.duplicate_for_brands && e?.parentId
                  ? e?.originalWidgetName
                  : e?.widget_name
                  ? e?.widget_name
                  : null,
              base: e?.base ? e?.base : "mentions",
              type: e?.type ? e?.type : "graph",
              text:
                e?.type === "rich-content" || e?.chart?.chart_type === "text"
                  ? e?.text
                  : undefined,
              relative_duration: e?.relative_duration || null,
              start_date: e?.duration?.from ? e?.duration?.from : e?.start_date,
              end_date: e?.duration?.to ? e?.duration?.to : e?.end_date,
              is_locked: e?.is_locked ? e?.is_locked : false,
              span: e?.span ? e?.span : "full",
              differential: e?.differential,
              original_widget_id:
                e?.type === "predefined" && isEditTemplate
                  ? e?.original_widget_id
                    ? e?.original_widget_id
                    : e?.widget_id
                  : e?.widget_id,
              is_imported: e?.type === "predefined" ? true : false,
              source_template: e?.source_template
                ? e?.source_template
                : e?.template_id,
              stacked: e?.stacked,
              percent: e?.percent,
              brand_list: e?.brands
                ? single_brands1?.length > 0
                  ? single_brands1
                  : []
                : [],
              brand_groups: e?.brands
                ? brandsGroupName1?.length > 0
                  ? brandsGroupName1
                  : []
                : [],
              log: e?.log,
              data_source: e?.data_source,
              widget_id: e?.widget_id,
              engine: e?.engine,
              supported_filters: e?.supported_filters,
              profile_filters: e?.profile_filters,
              widget_uuid: e?.widget_uuid,
              widget_description_on_icon: e?.widget_description_on_icon,
              widget_description: e?.widget_description,
              note: e?.note || null,
            });
          }
          if (e?.duplicate_for_brands && e?.parentId) {
            e["widget_name"] = e?.originalWidgetName;
            delete e?.duplicate_for_brands;
            delete e?.parentId;
            delete e?.childId;
            delete e?.span;
            delete e?.originalWidgetName;
            delete e?.com_brand_ids;
          }
        }
      });
    });
    let templateData = {
      templateFilters: filtersData,
      template_name: isModalSaveAs
        ? dashboardName
        : panes?.[index]?.template_name
        ? panes?.[index]?.template_name
        : "",
      template_description: isModalSaveAs
        ? dashboardDescription?.length
          ? dashboardDescription
          : ""
        : panes?.[index]?.template_description
        ? panes?.[index]?.template_description.trim()
        : "",
      contains_section: panes?.[index]?.sections
        ? true
        : panesSection[0]?.onlyWidgets || !panesSection[0]?.isSectionAdded
        ? false
        : sectionDetails?.isSectionAdded
        ? true
        : false,
      template_type: panes?.[index]?.template_type
        ? panes?.[index]?.template_type
        : "custom",
      hidden_filter:
        channelList !== ""
          ? {
              attribute: "SocialMediaPlatforms",
              type: "varchar",
              columns: [
                {
                  name: channelList,
                  type: "include",
                },
              ],
            }
          : panes?.[index]?.hidden_filter
          ? panes?.[index]?.hidden_filter
          : null,
      quick_filter: quickFilter ? quickFilter : panes?.[index]?.quick_filter,
      is_date_locked: panes?.[index]?.is_date_locked,
      is_brand_locked: panes?.[index]?.is_brand_locked,
      competition_aggregation:
        panes?.[index]?.template_type !== "custom"
          ? panes?.[index]?.competition_aggregation
          : null,
      templateType: panes?.[index]?.template_type
        ? panes?.[index]?.template_type
        : "custom",
    };
    // currently not allowing
    // let relativeDuration = null;
    // if (panes[index]?.duration?.save_as_relative) {
    //   relativeDuration = {};
    //   relativeDuration.relative = {
    //     type: "short",
    //     value: panes[index]?.duration?.relative?.value,
    //   };
    //   relativeDuration.save_as_relative =
    //     panes[index]?.duration?.save_as_relative;
    // }

    let paneObj = {
      template_update: true,
      panes: panes,
      activeKey: activeKey,
      index: index,
      brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
      singleBrands: Allbrands,
      competitorBrands: competitorBrands,
      global_dashboard_duration: global_dashboard_duration,
      global_dashboard_brands:
        panes[index].template_type === "ticket"
          ? global_dashboard_single_brands
          : global_dashboard_brands,
      graphConditionConfig: graphConditionConfig,
      type: window.location.pathname === "/schedule" ? "report" : "dashboard",
      save_as: isModalSaveAs,
      is_recommended: panes?.[index]?.predefined,
      original_template_id: isModalSaveAs ? null : panes?.[index]?.template_id,
      edited_dashboard_flow: true,
      // relativeDuration: relativeDuration,
    };

    let basicObj = getTemplateListBasicObject(
      authParams,
      panes,
      index,
      pageSize,
      graphConditionConfig
    );

    // console.log(
    //   "templateData",
    //   templateData,
    //   "sectionObject",
    //   sectionObject,
    //   "widgetObject",
    //   widgetObject
    // );
    // Update dashborad API Call
    let templateDetails = {
      start_date: panes?.[index]?.duration?.from,
      end_date: panes?.[index]?.duration?.to,
    };
    dispatch(
      setEditTemplate(
        basicObj,
        panes?.[index]?.template_id,
        templateData,
        panes?.[index]?.sections ? sectionObject : null,
        widgetObject,
        paneObj,
        templateDetails
      )
    );
  };

  const handleDashboardName = (e) => {
    setflag(true);
    setDashboardName(e.target.value);
  };

  const handleDashboardDescription = (e) => {
    setflag(true);
    setDashboardDescription(e.target.value);
  };

  return (
    <Modal
      // title={
      //   <div className="d-flex justify-content-between">Save Dashboard</div>
      // }
      open={isModalShow}
      onOk={handleSaveAsDashboard}
      onCancel={handleCancel}
      footer={[
        (closeDashboardFlag || openNewDashboardFlag) && (
          <Button
            style={{ float: "left" }}
            type="button"
            className="btn_Clear"
            onClick={handleDontSave}
          >
            Don't Save & Exit
          </Button>
        ),
        !isModalSaveAs && (
          <Button
            type="primary"
            // type="button"
            // className="ant-btn-primary_blue"
            onClick={handleSaveAsDashboard}
            loading={duplicateDashboardLoader ? true : false}
          >
            Save Dashboard
          </Button>
        ),
        isModalSaveAs ? (
          <Button
            type="primary"
            // className="ant-btn-primary_blue"
            onClick={handleCreateNewDashboard}
          >
            Save As
          </Button>
        ) : (
          <Button
            type="primary"
            // className="ant-btn-primary_blue"
            onClick={() => setIsModalSaveAs(true)}
          >
            Save As
          </Button>
        ),
      ]}
      width={580}
      closable={true}
      maskClosable={false}
      className={
        authParams?.theme_type === "1" ? "formModal darkTheme" : "lightTheme"
      }
    >
      {isModalSaveAs ? (
        <>
          <div className="w-100">
            <div className="position-relative floating-label-group header-brands mb-15">
              <Input
                required
                id="outlined-required"
                inputRef={inputRef}
                maxLength={100}
                InputLabelProps={{
                  shrink:
                    dashboardName && dashboardName?.trim().length > 0
                      ? true
                      : false,
                }}
                value={dashboardName}
                error={flag && dashboardName?.trim()?.length === 0}
                onChange={(e) => handleDashboardName(e)}
                className="border-radius-4 border-color"
              />
              {flag && dashboardName?.trim()?.length === 0 && (
                <span className="error">Dashboard name cannot be empty *</span>
              )}
              <label className="portlet-label floating-label">
                Enter new dashboard name
              </label>
              <span
                className="text-gray position-absolute font-size12"
                style={{
                  right: "0.3rem",
                  bottom: "0.1rem",
                }}
              >
                {dashboardName?.length > 0 ? dashboardName?.length : "0"}/100
              </span>
            </div>

            <div className="position-relative mt-15 floating-label-group header-brands">
              <TextArea
                rows={4}
                id="outlined-required"
                inputRef={inputRef}
                maxLength={150}
                InputLabelProps={{
                  shrink:
                    dashboardDescription &&
                    dashboardDescription?.trim().length > 0
                      ? true
                      : false,
                }}
                value={dashboardDescription}
                onChange={(e) => handleDashboardDescription(e)}
                className="border-radius-4 border-color pt-2"
                style={{ resize: "none" }}
              />
              <label className="portlet-label floating-label line-height-normal">
                Enter new dashboard description
              </label>
              <span
                className="text-gray position-absolute font-size12"
                style={{
                  right: "0.3rem",
                  bottom: "0.1rem",
                }}
              >
                {dashboardDescription?.length > 0
                  ? dashboardDescription?.length
                  : "0"}
                /150
              </span>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="text_heading-Slab text-transform__none mt-2">
            What would you like to do with your dashboard?
            <p className="share_link_sub_text mt-15">
              To save the changes you’ve made to this dashboard, simply click
              "Save Dashboard." If you want to create a duplicate version with
              the same setup, choose "Save As."
            </p>
          </div>
        </>
      )}
    </Modal>
  );
};

export default memo(SaveEditedDashboardModal);
